module.exports = __webpack_public_path__ + "static/media/campana_salida_blanco.73199557.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallRecord/campana_salida_blanco.svg
// module id = 1736
// module chunks = 0